var _circle, _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUsersLight(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 3.40426,
    cy: 3.40426,
    r: 3.40426,
    transform: "matrix(-1 0 0 1 15.6172 5)",
    stroke: "white",
    strokeWidth: 1.3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.25537 16.8594C6.25537 16.1272 6.71567 15.474 7.40524 15.2277V15.2277C10.5141 14.1174 13.9115 14.1174 17.0204 15.2277V15.2277C17.71 15.474 18.1703 16.1272 18.1703 16.8594V17.979C18.1703 18.9896 17.2752 19.7659 16.2748 19.6229L15.9412 19.5753C13.4682 19.222 10.9575 19.222 8.48442 19.5753L8.15087 19.6229C7.15044 19.7659 6.25537 18.9896 6.25537 17.979V16.8594Z",
    stroke: "white",
    strokeWidth: 1.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3194 11.9028C18.7966 11.9028 19.9941 10.7052 19.9941 9.22799C19.9941 7.75076 18.7966 6.55322 17.3194 6.55322",
    stroke: "white",
    strokeWidth: 1.3,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2486 18.0051L20.5106 18.0425C21.2967 18.1548 22 17.5448 22 16.7508V15.8711C22 15.2958 21.6383 14.7826 21.0965 14.5891C20.5561 14.3961 20.0045 14.2458 19.4468 14.1382",
    stroke: "white",
    strokeWidth: 1.3,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.68063 11.9028C5.2034 11.9028 4.00586 10.7052 4.00586 9.22799C4.00586 7.75076 5.2034 6.55322 6.68063 6.55322",
    stroke: "white",
    strokeWidth: 1.3,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.75143 18.0051L3.48935 18.0425C2.7033 18.1548 2.00003 17.5448 2.00003 16.7508V15.8711C2.00003 15.2958 2.3617 14.7826 2.9035 14.5891C3.44395 14.3961 3.99549 14.2458 4.55322 14.1382",
    stroke: "white",
    strokeWidth: 1.3,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersLight);
export default __webpack_public_path__ + "static/media/users-light.eb2a92199f037297434d82e786c56871.svg";
export { ForwardRef as ReactComponent };